import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="works-body">
						<div className="work">
							<img
								src="./react.webp"
								alt="React"
								className="work-image"
							/>
							<div className="work-title">Techquench Solution PVT. LTD.</div>
							<div className="work-subtitle">
							MERN STACK DEVELOPER
							</div>
							<div className="work-duration">01 Mar 2022 - 20-Nov-2022</div>
						</div>

						<div className="work">
							<img
								src="./react.webp"
								alt="React"
								className="work-image"
							/>
							<div className="work-title">DRAGGITAL</div>
							<div className="work-subtitle">
							MERN Stack developer
							</div>
							<div className="work-duration">01 Aug 2021 - 28 Feb 2022</div>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;
